module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNi41IiB3aWR0aD0iMyIgaGVpZ2h0PSIxMiIgcng9IjEuNSIgZmlsbD0iIzE2NDE5MyIvPgo8cmVjdCB4PSIwLjUiIHdpZHRoPSIzIiBoZWlnaHQ9IjEyIiByeD0iMS41IiBmaWxsPSIjMTY0MTkzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/images/bt-pause.svg
// module id = TV7+
// module chunks = 11